// ※サーバから返ってきている情報を使っている項目で、ページに反映されないデータもあるので注意
const imgPath = '/static/img/yearluck/y2023/'
const dirKey = 'somarimone'

const info = {
  name: 'そまり百音',
  itemId: 6405,
  lpId: 6, //なければ0
  pkgTitle: '暮れの酉の2022年のあなたの運勢あああああああああああああああ',
  price: 999,
  memberPrice: 500,
  pkgDescription: 'パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。',
  pkgNotice: '',
}

const top = {
  thumbnail: `${imgPath}top/counselor/${dirKey}/top_thumnail.png`,
  pkgTitleImg: `${imgPath}top/counselor/${dirKey}/top_pkg_title_img.png`,
  pkgBackImg: `${imgPath}top/counselor/${dirKey}/top_bg.png`,
}

const input = {
  thumbnail: `${imgPath}input/counselor/${dirKey}/input_thumnail.png`,
  fukiImage: `${imgPath}input/counselor/${dirKey}/input_fuki.png`,
  pkgBackImg: `${imgPath}input/counselor/${dirKey}/bg_topinfo.png`,
  headInfoBgUpp: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_upper.png`,
  headInfoBgMdl: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_middle.png`,
}

const result = {
  title: 'ねこ風水のそまり百音が占う<br>◆2023年の運勢詳細版				',
  thumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon.png`,
  underThumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon.png`,
  description: '鑑定に来てくださり、ありがとうございます。あなたの2023年の運勢、しっかりと占わせていただきます。まずは、全体を通してどんな年になるのか？　1年の流れからお伝えいたします。',
  bottomFukiMessage: '鑑定はいかがでしたか？　あなたの新しい1年が充実したステキな年になりますように。<br>続いて、もう少しあなたにお伝えしたいことがあります。',
}

export default {
  info,
  top,
  input,
  result,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/YearLuck/y2023/data/counselor/pkg05_somari_mone.js